import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Col} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {PulseLoader} from 'react-spinners';
import styled from 'styled-components';
import {COLORS} from '../../constants';
import Tooltip from '../Tooltip';

const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
`;

const Input = styled.input`
  background: ${({disabled}) => disabled ? COLORS.BACKGROUND_GRAY : COLORS.WHITE};
  font-size: 14px;
`;

class MandatoryInput extends PureComponent {
  render() {
    const {title, size, loading, onChange, type, value, t, show, customText, name, disabled, Component, ...rest} = this.props;
    let style = {};

    if (show) {
      style = {boxShadow: '0 0 5px rgba(255,0,0,1)'};
    }

    if (this.props.type === 'date') {
      style = {fontSize: '14px'};
    }

    return (
      <Col xs={size}>
        <label>
          <AttributeDiv className="label-name">{title}</AttributeDiv>
          {loading ? (
            <PulseLoader loading={loading} />
          ) : (
            <Component
              type={type}
              name={name}
              value={value}
              style={style}
              onChange={e => onChange(name, e.target.value)}
              disabled={disabled}
              {...rest}
            />
          )}
        </label>
        <Tooltip show={show} color={'red'}>
          {customText || t('requiredField')}
        </Tooltip>
      </Col>
    );
  }
}

MandatoryInput.defaultProps = {
  type: 'text',
  size: 12,
  loading: false,
  show: false,
  value: '',
  disabled: false,
  Component: Input,
};

MandatoryInput.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any,
  loading: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  customText: PropTypes.string,
  disabled: PropTypes.bool,
  Component: PropTypes.any,
};

export default withTranslation('common')(MandatoryInput);
